var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersTestiimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.307 18.9193C20.3614 18.9266 20.4159 18.934 20.4703 18.9416L20.7438 18.98C21.9346 19.1471 23 18.2395 23 17.0579V16.1561C23 15.311 22.4592 14.5572 21.649 14.273C20.7129 13.9446 19.7466 13.7308 18.7711 13.6316C19.789 14.3675 20.4203 15.5592 20.4203 16.8593V17.9789C20.4203 18.304 20.3809 18.6189 20.307 18.9193ZM16.1812 12.4319C16.5868 12.5994 17.0324 12.6919 17.5 12.6919C19.3813 12.6919 20.9064 11.1939 20.9064 9.34591C20.9064 7.49795 19.3813 5.99988 17.5 5.99988C17.4443 5.99988 17.3889 6.00119 17.3338 6.00379C17.6759 6.7324 17.8671 7.54594 17.8671 8.40413C17.8671 9.98064 17.2219 11.4064 16.1812 12.4319Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.07387 18.9193C4.01942 18.9266 3.96499 18.934 3.91058 18.9416L3.63707 18.98C2.44625 19.1471 1.38084 18.2395 1.38084 17.0579V16.1561C1.38084 15.311 1.92166 14.5572 2.73185 14.273C3.66791 13.9446 4.63427 13.7308 5.60979 13.6316C4.59191 14.3675 3.96057 15.5592 3.96057 16.8593V17.9789C3.96057 18.304 3.99992 18.6189 4.07387 18.9193ZM8.19971 12.4319C7.79406 12.5994 7.34845 12.6919 6.88084 12.6919C4.99952 12.6919 3.47442 11.1939 3.47442 9.34591C3.47442 7.49795 4.99952 5.99988 6.88084 5.99988C6.93657 5.99988 6.992 6.00119 7.04707 6.00379C6.70496 6.7324 6.51377 7.54594 6.51377 8.40413C6.51377 9.98064 7.15896 11.4064 8.19971 12.4319Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3671 8.40413C16.3671 6.1098 14.5071 4.24988 12.2128 4.24988C9.91848 4.24988 8.05856 6.1098 8.05856 8.40413C8.05856 10.6985 9.91848 12.5584 12.2128 12.5584C14.5071 12.5584 16.3671 10.6985 16.3671 8.40413Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15298 14.5213C10.425 13.3528 14.0006 13.3528 17.2727 14.5213C18.2607 14.8742 18.9203 15.8101 18.9203 16.8593V17.9789C18.9203 19.4459 17.621 20.5728 16.1687 20.3653L15.8351 20.3177C13.4325 19.9744 10.9932 19.9744 8.59049 20.3177L8.25693 20.3653C6.80468 20.5728 5.50537 19.4459 5.50537 17.9789V16.8593C5.50537 15.8101 6.16492 14.8742 7.15298 14.5213Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersTestiimg);
export default __webpack_public_path__ + "static/media/UsersTestiimg.2d8369cf6371fff764acefb31103a047.svg";
export { ForwardRef as ReactComponent };